var _defs, _title, _g, _g2, _g3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMessetransport = function SvgMessetransport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 837.28 333.15",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4b8fcc;}.cls-2{fill:#fff;}"))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Neues Icon_AV_Messetransport")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transporter_gesch.",
    "data-name": "Transporter gesch."
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M633.61,114.13l-.31-.93H628c1.88,10.14,22.82,46.56,43.45,52.88,6.41,2,17.82,8.78,110.18,32L678.91,162.2C659,155,640.48,134.19,633.61,114.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282,257.11c108.86-8,244.09-11,391.74,1.58a52.5,52.5,0,0,1,5.14-5.3c-83.82-9.64-218.78-17.24-404.6-3.29A51.35,51.35,0,0,1,282,257.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.52,256.52l9,10.65s348.74-77.41,764.12-21.43C781.67,245.74,522.32,176,8.52,256.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M812.07,211.6,692.75,180.42c-72.22-17.64-77.1-88-77.1-88,58.33,7.27,110.8,23.79,138.22,53.09,28.14,30.06,38.69,54.84,38.69,54.84C740.7,54.68,492,0,492,0s88.24,37.43,90.19,48.06c8,43.62,12.42,131.46,12.29,151.51,96.26,9.4,170.39,26.67,170.39,26.67-39.46-10.12-162.48-19.06-162.48-19.06C196.09,201.28,0,246.48,0,246.48L27.08,278.4c63.56-9.63,123.07-16.91,178.64-22.35a51.84,51.84,0,0,1,68.59-6c185.82-13.95,320.78-6.35,404.6,3.29a51.89,51.89,0,0,1,79.66,12c15.35,3,23.1,5.08,23.1,5.08-7.29-1-14.53-1.88-21.77-2.77a51.76,51.76,0,0,1,6,24.2c0,1.58-.1,3.13-.23,4.67h70.69C843,267.88,812.07,211.6,812.07,211.6ZM17.55,267.17l-9-10.65c513.8-80.51,773.15-10.78,773.15-10.78C366.29,189.76,17.55,267.17,17.55,267.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282,257.11A51.74,51.74,0,0,1,295.25,288c172.69,1.33,365.64,8.56,365.64,8.56s.24-1.81.9-4.69a51.77,51.77,0,0,1,12-33.19C526.12,246.14,390.89,249.09,282,257.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.45,288.27l7,8.3c24.67-5.29,80.52-7.74,149-8.5a51.63,51.63,0,0,1,7.61-23.49C120.19,273,62.74,283,35.45,288.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.45,287.94a41.28,41.28,0,0,0-31.57-36.15,41.69,41.69,0,0,0-9.48-1.13A41.27,41.27,0,0,0,202.35,288a39.32,39.32,0,0,0-.2,3.93,41.25,41.25,0,1,0,82.5,0C284.65,290.57,284.57,289.24,284.45,287.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M742.7,262.46a41.23,41.23,0,1,0,12.39,29.44A41.11,41.11,0,0,0,742.7,262.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.44,130.17c2.06.18,1.9.13,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.44,130.17l-.25,0H258Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.39,112.83l.65.36,1.31-.36Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Details"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.66,79.35l9.15,153.78C191.19,201.81,364.78,190,556.4,201L547.25,47.26C364.2,22.1,234.05,12.72,7.66,79.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M333.05,62.15l-1.09,122c74.32-4.54,115.81-5.11,184.93,1.66l1.09-122C446.05,43.31,420.75,41.22,333.05,62.15Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "460.95 106.37 460.94 106.37 460.94 106.37 460.95 106.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M418,108.63c24.78-1.71,42.94-2.26,43-2.26h0A319.94,319.94,0,0,0,418,108.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177,150.3a27.06,27.06,0,1,0,28.23,26.56A27.42,27.42,0,0,0,177,150.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M448.13,129.72A27.4,27.4,0,0,0,421.58,158a27.75,27.75,0,0,0,28.23,26.55,27.4,27.4,0,1,0-1.68-54.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228,109.37c2.06.12,1.9.08,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228,109.37h-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.39,93.09l.65.34,1.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M539.83,164.77c18.3-12.17,10.28-17.43,10.28-17.43-34.44-27.72-68.43-37.52-89.17-41,0,0-18.19.55-43,2.26-25.53,2.92-56.61,8.84-94,19.23-61.75,17.15-124.09,1.53-124.09,1.53s49.37,9.46,113.61-6.92c29.24-7.45,72.41-11.62,104.5-13.84a319.94,319.94,0,0,1,43-2.26,115.41,115.41,0,0,0-20.23-1.86L419,100.26C318,45.38,217.56,69.09,160.45,97.37s-104,49.4-104,49.4,28.37-5.76,31.26-5.44,7.86,17,22.89,9.56c0,0,14.47,41.62,30.09,39.9l6.51-.73a33.08,33.08,0,1,1,63.31-7.44c37.24-9.46,144.77-11.2,208.58-11.35a33.07,33.07,0,1,1,59.79-.14c9.68-.29,26-.55,49.3-1.51C533,169.42,540,164.64,539.83,164.77ZM223.56,108.7,194,93.43c-24.7,7.58-40.19,14.89-40.19,14.89,96.2-48.09,169.26-38.85,209.43-26h0C385.88,89.58,398.09,98,398.09,98A202.36,202.36,0,0,0,363.92,85.2c1.6,2.76,6,8.13,17.44,18.67L353.74,82.63c-59.48-13.37-119.8-1.31-158.4,10.4l3.4-.11,29,16.44H228c1.9.08,2.06.12,0,0l-.47,0c-14.26-.69-100,11.74-100,11.74,37.48-13.22,89.29-12.16,100-11.74h.22ZM105.09,132.29c112.53-28.81,288.85-21.76,288.85-21.76C268.08,107.86,105.09,132.29,105.09,132.29ZM217,163.71c52.83,1.09,189.76-12,189.76-12C311.72,173.18,217,163.71,217,163.71Z"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessetransport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Messetransport.85551420.svg";
export { ForwardRef as ReactComponent };